import { render, staticRenderFns } from "./FloatButton.vue?vue&type=template&id=49ad8488"
import script from "./FloatButton.vue?vue&type=script&lang=js"
export * from "./FloatButton.vue?vue&type=script&lang=js"
import style0 from "./FloatButton.vue?vue&type=style&index=0&id=49ad8488&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports